// src/utils/currencyUtils.js

export function currency_converter_inr(num) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
}

export function currency_converter_selected(num) {
  const amount = Number(num || 0);

  let user = {};
  let currencies = [];

  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
    currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
  } catch (error) {
    console.error("Error reading currency data:", error);
  }

  const defaultCurrencyId = Number(user?.default_currency_id || 1);

  const selectedCurrency = currencies.find(
    (currency) =>
      Number(currency.value) === defaultCurrencyId
  );
  const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");

  // INR -> Indian numbering
  if (defaultCurrencyId === 1) {
    return `${symbol}${new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount)}`;
  }

  // Other currencies -> International numbering
  return `${symbol}${new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)}`;
}

export function format_currency(num) {
  const isFloat = !Number.isInteger(num);
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: isFloat ? 0 : 0, // show 2 decimals only if float
    maximumFractionDigits: isFloat ? 0 : 0,
  }).format(num);
}

export function currency_converter_inr_million(num) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num / 1000000);
}
